import { axiosGet, axiosPost } from "./apiClient";
const BASE_URL = `${process.env.REACT_APP_BASE_URL}/menu`;

const getMenus = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {} }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;
    return await axiosGet(`${BASE_URL}/get`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
    });
};
const getRoles = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {} }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;
    return await axiosGet(`${BASE_URL}/role/get`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
    });
};

const updateRoleStatus = async (params) => {
    return await axiosPost(`${BASE_URL}/role/status/`, { ...params });
};

const createRole = async (roleData) => {
    return await axiosPost(`${BASE_URL}/role/create`, roleData);
};
const getMenusByRole = async (id, includeInactive = false) => {
    return await axiosGet(`${BASE_URL}/role/${id}/menus`, { id, includeInactive });
}

const getRoleDetails = async ({ id }) => {
    return await axiosGet(`${BASE_URL}/role/detail`, { id });
};
const getRoleStatusLog = async (params) => {
    return await axiosPost(`${BASE_URL}/role/status/log`, { ...params });
};
const assignMenusToRole = async (params) => {
    return await axiosPost(`${BASE_URL}/role/assign-menus`, { ...params }); 
}

// Fetch every page; menu assignment must not silently truncate after 100 records.
const getAllRoleMenus = async () => {
    const menus = new Map();
    let page = 0;
    let total = Infinity;
    while (menus.size < total) {
        const response = await getMenus({ limit: 100, page });
        if (response.status !== "SUCCESS" || !Array.isArray(response.data?.result)) {
            throw new Error(response.message || "Unable to load menus.");
        }
        const rows = response.data.result;
        total = Number(response.data.totalRecords);
        if (!Number.isFinite(total) || total < 0) throw new Error("Invalid menu count returned by server.");
        const previousSize = menus.size;
        rows.forEach(menu => menus.set(Number(menu.id), menu));
        if (menus.size < total && menus.size === previousSize) throw new Error("Incomplete menu list returned by server. Please retry.");
        page += 1;
    }
    return [...menus.values()];
};

// Export the API functions
const menuApi = {
    getMenus,
    getAllRoleMenus,
    updateRoleStatus,
    createRole,
    getRoles,
    getRoleDetails,
    getRoleStatusLog,
    getMenusByRole,
    assignMenusToRole
};

export default menuApi;
